import { type FC } from 'react';

type RoleAttributesTableProps = {
  availableAttributes: { [attributeName: string]: string[] };
  missingAttributes?: string[];
  className?: string;
};

export const RoleAttributesTable: FC<RoleAttributesTableProps> = ({
  availableAttributes,
  missingAttributes = [],
  className = '',
}) => {
  const hasAnyAttributes = Object.keys(availableAttributes).length > 0 || missingAttributes.length > 0;

  if (!hasAnyAttributes) {
    return null;
  }

  return (
    <div className={className}>
      <table className="consolidationModal__attributesTable">
        <thead>
          <tr className="consolidationModal__tableHeader">
            <th className="consolidationModal__tableHeaderCell consolidationModal__tableHeaderCell--attributeKey">
              Attribute Key
            </th>
            <th className="consolidationModal__tableHeaderCell">Resource Keys</th>
          </tr>
        </thead>
        <tbody>
          {Object.entries(availableAttributes).map(([name, values]) => (
            <tr key={name}>
              <td className="consolidationModal__tableCell consolidationModal__tableCell--attributeKey">{name}</td>
              <td className="consolidationModal__tableCell">{values.join(', ')}</td>
            </tr>
          ))}
          {missingAttributes.map((attr: string) => (
            <tr key={`missing-${attr}`}>
              <td className="consolidationModal__tableCell consolidationModal__tableCell--attributeKey">{attr}</td>
              <td className="consolidationModal__tableCell consolidationModal__tableCell--missing">
                No resource keys found
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {missingAttributes.length > 0 && (
        <div className="consolidationModal__warningMessage">
          ⚠️ Missing resource keys will cause empty resources in the resolved policy.
        </div>
      )}
    </div>
  );
};
